export const FormConsultarCertidoesAtivas = {
    idenTipoCertidao: null,
    numrCertidao: null
}

export const consultaCertidoesAtivas = {
    nomePessoa: '',
    numrCpfTitular: 0,
    numrCertidao: '',
    numrMatricula: null,
    dataQuitacao: false,
    flagSituacao: false,
    dataAutenticacao: false

}

const url = "/certidoes";
const urlRelatorio = '/relatorios'
const id = "id"

export function buscarPeloCodigo(codigo) {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/${codigo}`).then((res) => {
            resolve(res.data);
        })
    })
}

export function pesquisar(filtro) {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}?${filtro}`).then((res) => {
            resolve(res.data);
        });
    })
}

export function pesquisarAll() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}`).then((res) => {
            resolve(res.data);
        })
    })
}

export function pesquisarAllAtivas() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/listarativas`).then((res) => {
            resolve(res.data);
        })
    })
}

export function salvar(parm) {
    return new Promise(async (resolve, reject) => {
        if (parm[id] && parm[id] != 0) {
            await atualizar(parm).then((res) => {
                resolve({ ...res, type: "UPD" });
            });
        } else {
            //   await criar(parm).then((res) => {
            //       resolve({ ...res, type: "INS" });
            //   })
        }
    })
}

export function remover(data) {
    return new Promise((resolve, reject) => {
        window.$http.delete(`${url}/${data[id]}`).then((res) => {
            resolve();
        })
    })
}

export function atualizar(parm) {
    return new Promise((resolve, reject) => {
        window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}

export function bucaPersonalizada(parm, page) {
    return new Promise((resolve, reject) => {
        window.$http.post(`${url}/listarativascert?${page}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}

// Imprimir Certidões ativas
const urlcertidoes = '/relatorios/pdfdevariascertidoesativas'
export function imprimirAll(parm) {
    return new Promise((resolve, reject) => {
        window.$http.post(`${urlcertidoes}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}

// Imprimir Cártula de Crédito
// const urlcertidoesAtivas = '/relatorios/pdfdeumacertidaoativa'
const urlcertidoesAtivas = '/relatorios/pdfcartativas'
export function imprimirUmaCartuladeCredito(parm) {
    return new Promise((resolve, reject) => {
        window.$http.post(`${urlcertidoesAtivas}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}


const urlexportacao = "/relatorios/exceldecertidoesativas";
export function exportarAllAtivas(atributos) {
    return new Promise((resolve) => {
        window.$http.post(`${urlexportacao}`, JSON.stringify(atributos)).then((res) => {
            resolve(res.data);
        })
    })
}


// const urlexportacao = "relatorios/exceldecertidoeslegadas";
// export function exportarAll(atributos) {
//     return new Promise((resolve) => {
//         window.$http.post(`${urlexportacao}`, JSON.stringify(atributos)).then((res) => {
//             resolve(res.data);
//         })
//     })
// }
